import * as React from 'react';
import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import { EPathType } from '../../../types/promosPage';

export const usePathType = (pathType: EPathType): React.JSX.Element => {
  return React.useMemo(() => {
    switch (pathType) {
      case EPathType.Walk:
        return <IconMapWalk16 color="current_color" />;
      default:
        return <IconMapCar16 color="current_color" />;
    }
  }, [pathType]);
};
